import { CSSProperties, FC, useEffect, useState } from "react";
import FlexBox from "../flex-box";
import IconBox from "../icon-box";
import { PiHospitalLight } from "react-icons/pi";
import WorkingHoursChart from "../charts/working-hours-chart";
import useClinics from "lib/hooks/useClinics";
import LoadingBox from "../loading-box";

const maxWidth: CSSProperties = {
  maxWidth: "130px",
};

interface ClinicWidgetProps extends React.HTMLAttributes<HTMLDivElement> {
  clinic: Clinic;
  className?: string;
  isSelected?: boolean;
  onSelected?: (value: ClinicDetails) => void;
}

const ClinicWidget: FC<ClinicWidgetProps> = ({
  clinic,
  className,
  isSelected,
  onSelected,
  ...props
}) => {
  const { getCalenderDetails, loading } = useClinics();
  const [calendarDetails, setCalendarDetails] = useState<CalendarDetails>(null);

  useEffect(() => {
    if (clinic) {
      getCalenderDetails(clinic?.id, (value) => {
        setCalendarDetails(value[0]);
      });
    }
  }, [clinic]);

  return (
    <div
      className={`dash-widget ${className} ${isSelected ? "selected" : ""}`}
      onClick={() =>
        onSelected?.({
          clinic,
          calendar: calendarDetails,
        } as ClinicDetails)
      }
      {...props}
    >
      <FlexBox alignItems="center">
        <IconBox icon=<PiHospitalLight /> />
        <div>
          <div style={maxWidth} className="truncate">
            <strong>{clinic.name}</strong>
          </div>
          <div
            className="text-end truncate"
            style={maxWidth}
            title={clinic.address}
          >
            <small>{clinic.address}</small>
          </div>
        </div>
      </FlexBox>
      <div>
        <WorkingHoursChart
          workingHours={clinic?.availableHours ?? []}
          height={"120px"}
        />
      </div>
      {loading ? (
        <LoadingBox />
      ) : (
        <FlexBox className="">
          <div>
            Holidays: <strong>{calendarDetails?.holidays?.length ?? 0}</strong>
          </div>
          <div>
            Closed:{" "}
            <strong>
              {calendarDetails?.unavailableDates?.length ?? 0} days
            </strong>
          </div>
        </FlexBox>
      )}
    </div>
  );
};
export default ClinicWidget;
